// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Main Wrapper
========================================================= */

.stories_storiesWrapper__5gm6b {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: #f8f9fa;
}

/* =========================================================
   Year Navigation
========================================================= */

.stories_yearNavigation__jVRW1 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 50px 0 40px;
  padding: 15px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
}

.stories_yearBtn__0oxjj {
  width: 65px;
  height: 42px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition:
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease,
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.stories_yearBtn__0oxjj:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

.stories_activeYear__Shef- {
  color: #1a5f3f !important;
  background: #ffffff !important;
  border-color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}

/* =========================================================
   Stories Grid
========================================================= */

.stories_storiesGrid__AU9kh {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

/* =========================================================
   Story Card
========================================================= */

.stories_storyCard__RsKBm {
  position: relative;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.stories_storyCard__RsKBm::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  height: 4px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.stories_storyCard__RsKBm:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 30px rgba(26, 95, 63, 0.15);
}

.stories_storyCard__RsKBm:hover::before {
  transform: scaleX(1);
}

/* =========================================================
   Cover Image Container
========================================================= */

.stories_storyCoverContainer__uhB0K {
  position: relative;
  width: 100%;
  height: 230px;
  overflow: hidden;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.stories_storyCover__AAlno {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition:
    transform 0.4s ease,
    filter 0.4s ease;
}

.stories_storyCard__RsKBm:hover .stories_storyCover__AAlno {
  transform: scale(1.08);
  filter: brightness(0.7);
}

/* =========================================================
   Image Overlay
========================================================= */

.stories_storyOverlay__fV7yX {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 95, 63, 0);
  opacity: 0;
  z-index: 1;
  transition:
    background 0.35s ease,
    opacity 0.35s ease;
}

.stories_storyCard__RsKBm:hover .stories_storyOverlay__fV7yX {
  background: rgba(26, 95, 63, 0.55);
  opacity: 1;
}

/* =========================================================
   Hover Icon (Solid White Circle + Oil Green Icon color)
========================================================= */

.stories_storyIcon__owHPf {
  display: block;
  position: relative;
  z-index: 2;
  width: 60px;
  height: 60px;
  padding: 15px;
  box-sizing: border-box;
  object-fit: contain;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: scale(0.8);
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    filter 0.3s ease;
  filter: none;
}

.stories_storyCard__RsKBm:hover .stories_storyIcon__owHPf {
  opacity: 1;
  transform: scale(1);
}


/* =========================================================
   Story Content
========================================================= */

.stories_storyContent__YNWku {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 14px 14px;
  text-align: center;
}

.stories_storyTitle__W\\+ska {
  display: -webkit-box;
  max-width: 100%;
  margin: 0 0 10px;
  overflow: hidden;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  -webkit-text-fill-color: transparent;
}

/* =========================================================
   Enhanced Meta Row & Chips (Horizontal / Row layout)
========================================================= */


.stories_metastyle__VaUyu {
  width: 100%;
  padding-top: 10px;
  border-top: 1px solid #edf2f7;
}

.stories_storyMeta__ghvzT {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  line-height: 1;
}

.stories_storyDate__FjgRV {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  color: #1a5f3f;
  background: #f0fdf4;
  border-radius: 999px;
  font-weight: 600;
}


/* جداکننده ظریف بین تاریخ و نویسنده */

.stories_storyMetaDivider__JsKzG {
  color: #cbd5e1;
  -webkit-user-select: none;
          user-select: none;
  flex: 0 0 auto;
}


.stories_storyAuthor__HD29y {
  color: #475569;
  font-weight: 500;
}

.stories_storyKeywordInline__LeMR6 {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  color: #4b5563;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}

/* =========================================================
   Keywords Chips (Enhanced & Clean Layout)
========================================================= */

.stories_storyKeywords__hAY2v {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;
  max-width: 100%;
}

.stories_storyKeywordChip__un5sd {
  padding: 3px 10px;
  color: #3b5c43;
  background: #f4f9f4;
  border: 1px solid #e2efe3;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.stories_storyCard__RsKBm:hover .stories_storyKeywordChip__un5sd {
  background: #eaf5eb;
  border-color: #d1ebd3;
  color: #1a5f3f;
}

/* =========================================================
   Loading and Empty States
========================================================= */

.stories_loadingIndicator__3IJTs {
  margin: 20px 0;
  padding: 60px 20px;
  color: #1a5f3f;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.stories_noStoriesMessage__SdxKE {
  margin: 20px 0;
  padding: 60px 20px;
  color: #64748b;
  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  text-align: center;
  font-size: 16px;
}

/* =========================================================
   Load More Section
========================================================= */

.stories_loadMoreSection__fDuJO {
  margin-top: 30px;
  padding: 20px;
  text-align: center;
}

.stories_loadMoreBtn__goXZh {
  margin-bottom: 12px;
  padding: 14px 30px;
  color: #ffffff;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border: none;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.25);
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    background 0.3s ease;
}

.stories_loadMoreBtn__goXZh:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.35);
}

.stories_loadMoreBtn__goXZh:active {
  transform: translateY(0);
}

.stories_storyCount__vbBBo {
  display: inline-block;
  padding: 6px 14px;
  color: #64748b;
  background: rgba(26, 95, 63, 0.08);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

/* =========================================================
   Media Queries (Responsive)
========================================================= */

@media (max-width: 1024px) {
  .stories_storiesWrapper__5gm6b {
    width: 90%;
  }

  .stories_storiesGrid__AU9kh {
    gap: 22px;
  }

  .stories_storyCoverContainer__uhB0K {
    height: 210px;
  }
}

@media (max-width: 768px) {
  .stories_storiesWrapper__5gm6b {
    width: 95%;
    padding: 15px;
  }

  .stories_storiesGrid__AU9kh {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .stories_yearNavigation__jVRW1 {
    gap: 8px;
    margin-top: 30px;
    padding: 12px;
  }

  .stories_yearBtn__0oxjj {
    width: 52px;
    height: 40px;
    padding: 6px;
    font-size: 13px;
  }

  .stories_storyCoverContainer__uhB0K {
    height: 200px;
  }

  .stories_storyContent__YNWku {
    padding: 14px 12px;
  }

  .stories_storyTitle__W\\+ska {
    font-size: 15px;
  }

  .stories_storyIcon__owHPf {
    width: 44px;
    height: 44px;
    padding: 10px;
    position: relative;
  z-index: 2;
  filter: brightness(0) saturate(100%) invert(30%) sepia(18%) saturate(730%)
    hue-rotate(78deg) brightness(92%) contrast(88%);
  }
}

@media (max-width: 480px) {
  .stories_storiesWrapper__5gm6b {
    width: 100%;
    padding: 10px;
  }

  .stories_storiesGrid__AU9kh {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stories_yearNavigation__jVRW1 {
    margin-bottom: 25px;
  }

  .stories_yearBtn__0oxjj {
    width: 42px;
    height: 36px;
    font-size: 11px;
  }

  .stories_storyCoverContainer__uhB0K {
    height: 180px;
  }

  .stories_storyContent__YNWku {
    padding: 12px 10px;
  }

  .stories_storyTitle__W\\+ska {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .stories_storyMeta__ghvzT {
    gap: 6px;
    font-size: 10px;
  }

  .stories_storyKeywords__hAY2v {
    gap: 4px;
    margin-top: 6px;
  }

  .stories_storyKeywordChip__un5sd {
    padding: 2px 7px;
    font-size: 10px;
  }

  .stories_storyIcon__owHPf {
    width: 40px;
    height: 40px;
    padding: 9px;
  }

  .stories_loadMoreSection__fDuJO {
    padding: 15px 10px;
  }

  .stories_loadMoreBtn__goXZh {
    padding: 12px 22px;
    font-size: 14px;
  }
}

/* =========================================================
   Accessibility Focus States
========================================================= */

.stories_storyCard__RsKBm:focus-visible,
.stories_yearBtn__0oxjj:focus-visible,
.stories_loadMoreBtn__goXZh:focus-visible {
  outline: 3px solid #1a5f3f;
  outline-offset: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Main pages/stories.module.css"],"names":[],"mappings":"AAAA;;2DAE2D;;AAE3D;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;;2DAE2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB;;;;;wBAKsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;;2DAE2D;;AAE3D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;2DAE2D;;AAE3D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf;;wBAEsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;2DAE2D;;AAE3D;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;oBAEkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;2DAE2D;;AAE3D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,UAAU;EACV,UAAU;EACV;;sBAEoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;;2DAE2D;;AAE3D;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,qBAAqB;EACrB;;;oBAGkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;;AAGA;;2DAE2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;EAC7D,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;;2DAE2D;;;AAG3D;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;;AAGA,sCAAsC;;AAEtC;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2DAE2D;;AAE3D;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;2DAE2D;;AAE3D;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;2DAE2D;;AAE3D;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB;;;wBAGsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2DAE2D;;AAE3D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB,UAAU;EACV;mDACiD;EACjD;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;;2DAE2D;;AAE3D;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* =========================================================\n   Main Wrapper\n========================================================= */\n\n.storiesWrapper {\n  width: 80%;\n  margin: 0 auto;\n  padding: 20px;\n  direction: rtl;\n  background: #f8f9fa;\n}\n\n/* =========================================================\n   Year Navigation\n========================================================= */\n\n.yearNavigation {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 50px 0 40px;\n  padding: 15px;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  border-radius: 16px;\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\n}\n\n.yearBtn {\n  width: 65px;\n  height: 42px;\n  padding: 8px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition:\n    background 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease,\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.yearBtn:hover {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n.activeYear {\n  color: #1a5f3f !important;\n  background: #ffffff !important;\n  border-color: #ffffff !important;\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);\n}\n\n/* =========================================================\n   Stories Grid\n========================================================= */\n\n.storiesGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 30px;\n  margin-bottom: 40px;\n}\n\n/* =========================================================\n   Story Card\n========================================================= */\n\n.storyCard {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  overflow: hidden;\n  color: inherit;\n  text-decoration: none;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.storyCard::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  height: 4px;\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: transform 0.3s ease;\n}\n\n.storyCard:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 30px rgba(26, 95, 63, 0.15);\n}\n\n.storyCard:hover::before {\n  transform: scaleX(1);\n}\n\n/* =========================================================\n   Cover Image Container\n========================================================= */\n\n.storyCoverContainer {\n  position: relative;\n  width: 100%;\n  height: 230px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.storyCover {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition:\n    transform 0.4s ease,\n    filter 0.4s ease;\n}\n\n.storyCard:hover .storyCover {\n  transform: scale(1.08);\n  filter: brightness(0.7);\n}\n\n/* =========================================================\n   Image Overlay\n========================================================= */\n\n.storyOverlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 95, 63, 0);\n  opacity: 0;\n  z-index: 1;\n  transition:\n    background 0.35s ease,\n    opacity 0.35s ease;\n}\n\n.storyCard:hover .storyOverlay {\n  background: rgba(26, 95, 63, 0.55);\n  opacity: 1;\n}\n\n/* =========================================================\n   Hover Icon (Solid White Circle + Oil Green Icon color)\n========================================================= */\n\n.storyIcon {\n  display: block;\n  position: relative;\n  z-index: 2;\n  width: 60px;\n  height: 60px;\n  padding: 15px;\n  box-sizing: border-box;\n  object-fit: contain;\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n  opacity: 0;\n  transform: scale(0.8);\n  transition:\n    transform 0.3s ease,\n    opacity 0.3s ease,\n    filter 0.3s ease;\n  filter: none;\n}\n\n.storyCard:hover .storyIcon {\n  opacity: 1;\n  transform: scale(1);\n}\n\n\n/* =========================================================\n   Story Content\n========================================================= */\n\n.storyContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 14px 14px;\n  text-align: center;\n}\n\n.storyTitle {\n  display: -webkit-box;\n  max-width: 100%;\n  margin: 0 0 10px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.35;\n  -webkit-text-fill-color: transparent;\n}\n\n/* =========================================================\n   Enhanced Meta Row & Chips (Horizontal / Row layout)\n========================================================= */\n\n\n.metastyle {\n  width: 100%;\n  padding-top: 10px;\n  border-top: 1px solid #edf2f7;\n}\n\n.storyMeta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.storyDate {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  color: #1a5f3f;\n  background: #f0fdf4;\n  border-radius: 999px;\n  font-weight: 600;\n}\n\n\n/* جداکننده ظریف بین تاریخ و نویسنده */\n\n.storyMetaDivider {\n  color: #cbd5e1;\n  user-select: none;\n  flex: 0 0 auto;\n}\n\n\n.storyAuthor {\n  color: #475569;\n  font-weight: 500;\n}\n\n.storyKeywordInline {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  color: #4b5563;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n/* =========================================================\n   Keywords Chips (Enhanced & Clean Layout)\n========================================================= */\n\n.storyKeywords {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 4px;\n  max-width: 100%;\n}\n\n.storyKeywordChip {\n  padding: 3px 10px;\n  color: #3b5c43;\n  background: #f4f9f4;\n  border: 1px solid #e2efe3;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.4;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.storyCard:hover .storyKeywordChip {\n  background: #eaf5eb;\n  border-color: #d1ebd3;\n  color: #1a5f3f;\n}\n\n/* =========================================================\n   Loading and Empty States\n========================================================= */\n\n.loadingIndicator {\n  margin: 20px 0;\n  padding: 60px 20px;\n  color: #1a5f3f;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.noStoriesMessage {\n  margin: 20px 0;\n  padding: 60px 20px;\n  color: #64748b;\n  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);\n  border: 2px dashed #cbd5e1;\n  border-radius: 16px;\n  text-align: center;\n  font-size: 16px;\n}\n\n/* =========================================================\n   Load More Section\n========================================================= */\n\n.loadMoreSection {\n  margin-top: 30px;\n  padding: 20px;\n  text-align: center;\n}\n\n.loadMoreBtn {\n  margin-bottom: 12px;\n  padding: 14px 30px;\n  color: #ffffff;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.25);\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease,\n    background 0.3s ease;\n}\n\n.loadMoreBtn:hover {\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.35);\n}\n\n.loadMoreBtn:active {\n  transform: translateY(0);\n}\n\n.storyCount {\n  display: inline-block;\n  padding: 6px 14px;\n  color: #64748b;\n  background: rgba(26, 95, 63, 0.08);\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* =========================================================\n   Media Queries (Responsive)\n========================================================= */\n\n@media (max-width: 1024px) {\n  .storiesWrapper {\n    width: 90%;\n  }\n\n  .storiesGrid {\n    gap: 22px;\n  }\n\n  .storyCoverContainer {\n    height: 210px;\n  }\n}\n\n@media (max-width: 768px) {\n  .storiesWrapper {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .storiesGrid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .yearNavigation {\n    gap: 8px;\n    margin-top: 30px;\n    padding: 12px;\n  }\n\n  .yearBtn {\n    width: 52px;\n    height: 40px;\n    padding: 6px;\n    font-size: 13px;\n  }\n\n  .storyCoverContainer {\n    height: 200px;\n  }\n\n  .storyContent {\n    padding: 14px 12px;\n  }\n\n  .storyTitle {\n    font-size: 15px;\n  }\n\n  .storyIcon {\n    width: 44px;\n    height: 44px;\n    padding: 10px;\n    position: relative;\n  z-index: 2;\n  filter: brightness(0) saturate(100%) invert(30%) sepia(18%) saturate(730%)\n    hue-rotate(78deg) brightness(92%) contrast(88%);\n  }\n}\n\n@media (max-width: 480px) {\n  .storiesWrapper {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .storiesGrid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .yearNavigation {\n    margin-bottom: 25px;\n  }\n\n  .yearBtn {\n    width: 42px;\n    height: 36px;\n    font-size: 11px;\n  }\n\n  .storyCoverContainer {\n    height: 180px;\n  }\n\n  .storyContent {\n    padding: 12px 10px;\n  }\n\n  .storyTitle {\n    margin-bottom: 8px;\n    font-size: 14px;\n  }\n\n  .storyMeta {\n    gap: 6px;\n    font-size: 10px;\n  }\n\n  .storyKeywords {\n    gap: 4px;\n    margin-top: 6px;\n  }\n\n  .storyKeywordChip {\n    padding: 2px 7px;\n    font-size: 10px;\n  }\n\n  .storyIcon {\n    width: 40px;\n    height: 40px;\n    padding: 9px;\n  }\n\n  .loadMoreSection {\n    padding: 15px 10px;\n  }\n\n  .loadMoreBtn {\n    padding: 12px 22px;\n    font-size: 14px;\n  }\n}\n\n/* =========================================================\n   Accessibility Focus States\n========================================================= */\n\n.storyCard:focus-visible,\n.yearBtn:focus-visible,\n.loadMoreBtn:focus-visible {\n  outline: 3px solid #1a5f3f;\n  outline-offset: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storiesWrapper": `stories_storiesWrapper__5gm6b`,
	"yearNavigation": `stories_yearNavigation__jVRW1`,
	"yearBtn": `stories_yearBtn__0oxjj`,
	"activeYear": `stories_activeYear__Shef-`,
	"storiesGrid": `stories_storiesGrid__AU9kh`,
	"storyCard": `stories_storyCard__RsKBm`,
	"storyCoverContainer": `stories_storyCoverContainer__uhB0K`,
	"storyCover": `stories_storyCover__AAlno`,
	"storyOverlay": `stories_storyOverlay__fV7yX`,
	"storyIcon": `stories_storyIcon__owHPf`,
	"storyContent": `stories_storyContent__YNWku`,
	"storyTitle": `stories_storyTitle__W+ska`,
	"metastyle": `stories_metastyle__VaUyu`,
	"storyMeta": `stories_storyMeta__ghvzT`,
	"storyDate": `stories_storyDate__FjgRV`,
	"storyMetaDivider": `stories_storyMetaDivider__JsKzG`,
	"storyAuthor": `stories_storyAuthor__HD29y`,
	"storyKeywordInline": `stories_storyKeywordInline__LeMR6`,
	"storyKeywords": `stories_storyKeywords__hAY2v`,
	"storyKeywordChip": `stories_storyKeywordChip__un5sd`,
	"loadingIndicator": `stories_loadingIndicator__3IJTs`,
	"noStoriesMessage": `stories_noStoriesMessage__SdxKE`,
	"loadMoreSection": `stories_loadMoreSection__fDuJO`,
	"loadMoreBtn": `stories_loadMoreBtn__goXZh`,
	"storyCount": `stories_storyCount__vbBBo`
};
export default ___CSS_LOADER_EXPORT___;
